// This file was generated by lezer-generator. You probably shouldn't edit it.
export const VerbContent = 1,
    LstInlineContent = 2,
    LiteralArgContent = 3,
    SpaceDelimitedLiteralArgContent = 4,
    VerbatimContent = 5,
    Csname = 6,
    TrailingWhitespaceOnly = 7,
    TrailingContent = 8,
    hasMoreArguments = 392,
    endOfArguments = 393,
    hasMoreArgumentsOrOptionals = 394,
    endOfArgumentsAndOptionals = 395,
    Begin = 9,
    End = 10,
    RefCtrlSeq = 11,
    RefStarrableCtrlSeq = 12,
    CiteCtrlSeq = 13,
    CiteStarrableCtrlSeq = 14,
    LabelCtrlSeq = 15,
    MathTextCtrlSeq = 16,
    HboxCtrlSeq = 17,
    TitleCtrlSeq = 18,
    DocumentClassCtrlSeq = 19,
    UsePackageCtrlSeq = 20,
    HrefCtrlSeq = 21,
    UrlCtrlSeq = 22,
    VerbCtrlSeq = 23,
    LstInlineCtrlSeq = 24,
    IncludeGraphicsCtrlSeq = 25,
    IncludeSvgCtrlSeq = 26,
    CaptionCtrlSeq = 27,
    DefCtrlSeq = 28,
    LetCtrlSeq = 29,
    LeftCtrlSeq = 30,
    RightCtrlSeq = 31,
    NewCommandCtrlSeq = 32,
    RenewCommandCtrlSeq = 33,
    NewEnvironmentCtrlSeq = 34,
    RenewEnvironmentCtrlSeq = 35,
    BookCtrlSeq = 36,
    PartCtrlSeq = 37,
    ChapterCtrlSeq = 38,
    SectionCtrlSeq = 39,
    SubSectionCtrlSeq = 40,
    SubSubSectionCtrlSeq = 41,
    ParagraphCtrlSeq = 42,
    SubParagraphCtrlSeq = 43,
    InputCtrlSeq = 44,
    IncludeCtrlSeq = 45,
    SubfileCtrlSeq = 46,
    ItemCtrlSeq = 47,
    NewTheoremCtrlSeq = 48,
    TheoremStyleCtrlSeq = 49,
    CenteringCtrlSeq = 50,
    BibliographyCtrlSeq = 51,
    BibliographyStyleCtrlSeq = 52,
    AuthorCtrlSeq = 53,
    AffilCtrlSeq = 54,
    AffiliationCtrlSeq = 55,
    DateCtrlSeq = 56,
    MaketitleCtrlSeq = 57,
    TextColorCtrlSeq = 58,
    ColorBoxCtrlSeq = 59,
    HLineCtrlSeq = 60,
    TopRuleCtrlSeq = 61,
    MidRuleCtrlSeq = 62,
    BottomRuleCtrlSeq = 63,
    MultiColumnCtrlSeq = 64,
    ParBoxCtrlSeq = 65,
    TextBoldCtrlSeq = 66,
    TextItalicCtrlSeq = 67,
    TextSmallCapsCtrlSeq = 68,
    TextTeletypeCtrlSeq = 69,
    TextMediumCtrlSeq = 70,
    TextSansSerifCtrlSeq = 71,
    TextSuperscriptCtrlSeq = 72,
    TextSubscriptCtrlSeq = 73,
    TextStrikeOutCtrlSeq = 74,
    EmphasisCtrlSeq = 75,
    UnderlineCtrlSeq = 76,
    SetLengthCtrlSeq = 77,
    FootnoteCtrlSeq = 78,
    EndnoteCtrlSeq = 79,
    DocumentEnvName = 80,
    TabularEnvName = 81,
    EquationEnvName = 82,
    EquationArrayEnvName = 83,
    VerbatimEnvName = 84,
    TikzPictureEnvName = 85,
    FigureEnvName = 86,
    ListEnvName = 87,
    TableEnvName = 88,
    OpenParenCtrlSym = 89,
    CloseParenCtrlSym = 90,
    OpenBracketCtrlSym = 91,
    CloseBracketCtrlSym = 92,
    LineBreakCtrlSym = 93,
    Comment = 94,
    LaTeX = 95,
    Text = 96,
    BlankLine = 97,
    KnownEnvironment = 98,
    DocumentEnvironment = 99,
    OpenBrace = 102,
    CloseBrace = 103,
    OptionalArgument = 104,
    OpenBracket = 105,
    ShortOptionalArg = 106,
    Command = 107,
    Whitespace = 110,
    TextArgument = 111,
    LongArg = 112,
    CloseBracket = 113,
    Environment = 115,
    EnvName = 118,
    ShortTextArgument = 125,
    ShortArg = 126,
    PackageArgument = 135,
    UrlArgument = 139,
    FilePathArgument = 147,
    LabelArgument = 152,
    RefArgument = 154,
    BibKeyArgument = 156,
    CtrlSym = 158,
    MacroParameter = 159,
    OptionalMacroParameter = 160,
    DefinitionArgument = 161,
    NewLine = 162,
    DefinitionFragment = 163,
    DefinitionFragmentCommand = 164,
    CtrlSeq = 166,
    DefinitionFragmentArgument = 167,
    KnownCtrlSym = 168,
    Dollar = 171,
    Normal = 172,
    Ampersand = 173,
    Tilde = 174,
    SectioningArgument = 176,
    BareFilePathArgument = 185,
    TabularArgument = 197,
    TabularContent = 198,
    UnknownCommand = 215,
    DollarMath = 216,
    InlineMath = 217,
    Math = 218,
    MathCommand = 219,
    MathArgument = 234,
    MathDelimitedGroup = 288,
    MathOpening = 289,
    MathDelimiter = 290,
    MathClosing = 291,
    MathSpecialChar = 292,
    Number = 293,
    MathChar = 294,
    DisplayMath = 295,
    BracketMath = 296,
    OpenBracketMath = 297,
    CloseBracketMath = 298,
    ParenMath = 299,
    OpenParenMath = 300,
    CloseParenMath = 301,
    TabularEnvironment = 304,
    EquationEnvironment = 309,
    EquationArrayEnvironment = 314,
    VerbatimEnvironment = 318,
    TikzPictureEnvironment = 323,
    TikzPictureContent = 327,
    FigureEnvironment = 330,
    ListEnvironment = 334,
    TableEnvironment = 338,
    Book = 343,
    Part = 346,
    Chapter = 349,
    Section = 352,
    SubSection = 355,
    SubSubSection = 358,
    Paragraph = 361,
    SubParagraph = 364;
